<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	export let count: number | undefined = undefined;
	export let disabled: boolean = false;
	export let showCount: boolean = true;
	export let tooltip: string = '';
	export let showPrompt: boolean = false;

	const dispatch = createEventDispatcher();

	function handleClick() {
		if (!disabled) {
			dispatch('dig');
		}
	}
</script>

<div class="flex flex-col items-start gap-1 whitespace-nowrap relative">
	<div
		role="button"
		tabindex="0"
		id="dig-button"
		class="flex flex-row items-center hover:scale-105 relative group px-2 {disabled
			? 'opacity-50 cursor-not-allowed'
			: ''}"
		title={tooltip}
		on:click={handleClick}
		on:keyup={(e) => {
			if (e.key === 'Enter') handleClick();
		}}
		aria-disabled={disabled}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			class="group-hover:scale-110 transition-transform"
			><path
				d="m4.28 13.34-2.22 2.21C-.15 17.76-.53 20.47.67 22.89c.09.19.24.34.43.43 2.42 1.21 5.13.83 7.34-1.38l2.21-2.22c.28-.26.29-.7.03-.98l-1.62-1.61-1.44 1.44c-.62.53-1.54.5-2.12-.07a1.56 1.56 0 0 1-.09-2.12l1.44-1.44-1.61-1.63a.704.704 0 0 0-.98.03ZM19.48.21l4.31 4.32c.13.13.21.32.21.51s-.08.37-.21.51l-.89.89a2.83 2.83 0 0 1-3.98 0l-8.58 8.58-1.35-1.35 8.58-8.58a2.83 2.83 0 0 1 0-3.98l.89-.89c.13-.13.32-.21.51-.21s.37.08.51.21h.01ZM9.91 15.44l-2.7 2.7c-.18.19-.42.29-.68.29-.26 0-.5-.1-.69-.28s-.28-.43-.28-.69c0-.26.11-.5.29-.68l2.7-2.7 1.35 1.35ZM18.97 1.7l-.4.4c-.55.55-.55 1.44 0 1.99l1.34 1.34c.55.55 1.44.55 1.99 0l.4-.41-3.32-3.32Z"
				style="fill:#a5b9f6;fill-rule:evenodd;stroke-width:0"
			/></svg
		>
		<span class="ml-2 text-base md:text-lg">I dig it!</span>
		{#if showCount && typeof count === 'number' && count > 0}
			<div
				class="ml-2 text-base md:text-lg rounded-full bg-cosmicPurple100 text-cosmicPurple800 w-8 h-8 font-bold text-center flex items-center justify-center"
			>
				{count}
			</div>
		{/if}
	</div>
	{#if showPrompt}
		<div
			class="font-exo-2 text-base absolute top-14 w-64 bg-gradientBlue text-cosmicPurple800 px-4 py-2 rounded-xl z-10 break-words whitespace-normal"
		>
			<slot name="prompt" />
		</div>
	{/if}
</div>
